<template>
	<autocomplete :emails="emails"></autocomplete>
</template>
<script>
    export default {
        props: ['value'],

        data(){
        	return {
        		emails: [],
        		loading: false,
        	}
        },

        mounted: function () {
        	this.getEmails();
            var vm = this
            $(this.$el)
            .val(this.value)
            .on('change', function () {
                vm.$emit('input', this.value)
            })
        },
        watch: {
            value: function (value) {
                // update value
                $(this.$el).val(value)
            },
        },

        methods: {
        	getEmails: function(){
	    		var url = '/api/emails';
	    		this.loading = true;

	    		axios.get(url).then(response=>{
	    			this.emails = response.data;
	    		}).catch(error=>{
	    			console.log(error.response);
	    		}).then(()=>{
	    			this.loading = false;
	    		});
	    	},
        },
        destroyed: function () {
            //
        }
    }
</script>